var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMediumSeverity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "13px",
    viewBox: "0 0 12 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A Medium") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Investigations-small-screen",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-208.000000, -431.000000)",
    fill: "#E2B915",
    fillRule: "nonzero",
    id: "A-Medium"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(208.277822, 431.828928)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.61561285,0 C2.51419551,0 0,2.51839828 0,5.625 C0,8.73160172 2.51419551,11.25 5.61561285,11.25 C8.71703019,11.25 11.2312257,8.73160172 11.2312257,5.625 C11.2312257,2.51839828 8.71703019,0 5.61561285,0 Z M5.61561285,1.25 C8.02782634,1.25 9.98331174,3.20875422 9.98331174,5.625 C9.98331174,8.04124578 8.02782634,10 5.61561285,10 C3.20339937,10 1.24791397,8.04124578 1.24791397,5.625 C1.24791397,3.20875422 3.20339937,1.25 5.61561285,1.25 Z",
    id: "Oval"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumSeverity);
export default __webpack_public_path__ + "static/media/medium-severity.b4d88789f97a22acbc651f182362390f.svg";
export { ForwardRef as ReactComponent };